import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6666 0.833252H3.33331C2.67027 0.833252 2.03439 1.09664 1.56555 1.56548C1.09671 2.03433 0.833313 2.67021 0.833313 3.33325V16.6666C0.833313 17.3296 1.09671 17.9655 1.56555 18.4344C2.03439 18.9032 2.67027 19.1666 3.33331 19.1666H16.6666C17.3297 19.1666 17.9656 18.9032 18.4344 18.4344C18.9033 17.9655 19.1666 17.3296 19.1666 16.6666V3.33325C19.1666 2.67021 18.9033 2.03433 18.4344 1.56548C17.9656 1.09664 17.3297 0.833252 16.6666 0.833252V0.833252ZM17.5 16.6666C17.5 16.8876 17.4122 17.0996 17.2559 17.2558C17.0996 17.4121 16.8877 17.4999 16.6666 17.4999H3.33331C3.1123 17.4999 2.90034 17.4121 2.74406 17.2558C2.58778 17.0996 2.49998 16.8876 2.49998 16.6666V3.33325C2.49998 3.11224 2.58778 2.90028 2.74406 2.744C2.90034 2.58772 3.1123 2.49992 3.33331 2.49992H16.6666C16.8877 2.49992 17.0996 2.58772 17.2559 2.744C17.4122 2.90028 17.5 3.11224 17.5 3.33325V16.6666Z"
        fill="#DF692B"
      />
      <path
        d="M10.0018 15.0018C9.79662 15.0156 9.59424 14.9482 9.43833 14.8141C9.28243 14.68 9.18549 14.49 9.16846 14.2851V5.71844C9.18549 5.51352 9.28243 5.3235 9.43833 5.18942C9.59424 5.05534 9.79662 4.98794 10.0018 5.00178C10.207 4.98794 10.4093 5.05534 10.5652 5.18942C10.7212 5.3235 10.8181 5.51352 10.8351 5.71844V14.2851C10.8181 14.49 10.7212 14.68 10.5652 14.8141C10.4093 14.9482 10.207 15.0156 10.0018 15.0018V15.0018Z"
        fill="#DF692B"
      />
      <path
        d="M5.00178 10.0018C4.98794 9.79662 5.05534 9.59424 5.18942 9.43833C5.3235 9.28243 5.51352 9.18549 5.71844 9.16846H14.2851C14.49 9.18549 14.68 9.28243 14.8141 9.43833C14.9482 9.59424 15.0156 9.79662 15.0018 10.0018C15.0156 10.207 14.9482 10.4093 14.8141 10.5652C14.68 10.7212 14.49 10.8181 14.2851 10.8351H5.71844C5.51352 10.8181 5.3235 10.7212 5.18942 10.5652C5.05534 10.4093 4.98794 10.207 5.00178 10.0018V10.0018Z"
        fill="#DF692B"
      />
    </Svg>
  );
};

export default Icon;
